// extracted by mini-css-extract-plugin
export default {"signupForm":"signupForm_Az_CJ","joinTripspirationsLabel":"joinTripspirationsLabel_zvBzI","alreadyHaveAccountLabel":"alreadyHaveAccountLabel_rLqd_"};